<div class="bw-dialog info-dialog">

  <lib-page-header screenName="About" title="About BookWise">
    <mat-icon icon>info</mat-icon>
    <ng-container subtitle>
      <span>Intelligent bookkeeping for modern businesses</span>
    </ng-container>
  </lib-page-header>

  <div class="bw-body">
    <div class="about-hero">
      <img class="about-logo" src="logo.svg?v=2" alt="BookWise logo" width="96" height="96">
      <div class="about-wordmark">
        <span class="about-name">BookWise</span>
        <span class="about-tagline">Intelligent bookkeeping for modern businesses</span>
      </div>
    </div>

    <p class="intro">
      Welcome to BookWise, your intelligent companion for bookkeeping and financial management.
      We help businesses and accountants simplify their workflows, automate categorization, and maintain audit-ready records.
    </p>

    <h3>Our Mission</h3>
    <p>
      At BookWise, our mission is to empower businesses to work smarter with their finances.
      We bridge the gap between raw financial data and actionable insights through automation and AI.
    </p>

    <h3>Why Choose Us?</h3>
    <div class="feature-grid">
      <div class="feature-card">
        <mat-icon>auto_awesome</mat-icon>
        <strong>AI-Powered</strong>
        <span>Automatic receipt OCR and expense categorization</span>
      </div>
      <div class="feature-card">
        <mat-icon>group</mat-icon>
        <strong>Collaboration</strong>
        <span>Seamless client-accountant workflows</span>
      </div>
      <div class="feature-card">
        <mat-icon>tune</mat-icon>
        <strong>Customizable</strong>
        <span>Configurable categories, rules, and fiscal years</span>
      </div>
      <div class="feature-card">
        <mat-icon>security</mat-icon>
        <strong>Secure</strong>
        <span>Full audit trail, role-based access, encrypted storage</span>
      </div>
    </div>

    <h3>Our Story</h3>
    <p>
      BookWise was born from a passion for simplifying bookkeeping. What started as a small idea
      grew into a robust platform trusted by businesses and accounting firms.
    </p>
  </div>


</div>
